/* eslint-disable max-lines */
import { type AnimationWithMeta, type NullLayer, type ShapeLayer } from '../../lottie-player/types';

export const animationData: AnimationWithMeta = {
  v: '4.8.0',
  meta: { g: 'LottieFiles AE 3.1.1', a: '', k: '', d: '', tc: '' },
  fr: 60,
  ip: 60,
  op: 240,
  w: 1080,
  h: 1080,
  nm: 'MYSTORE LOADER - LEAFY GREEN',
  ddd: 0,
  assets: [],
  layers: [
    {
      ddd: 0,
      ind: 1,
      ty: 4,
      nm: 'magic bag/Mystore Loader_Icons Outlines',
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [539.246, 1070.358, 0], ix: 2 },
        a: { a: 0, k: [87.798, 185.342, 0], ix: 1 },
        s: {
          a: 1,
          k: [
            {
              i: { x: [0, 0, 0], y: [1, 1, 1] },
              o: { x: [0.05, 0.05, 0.05], y: [0, 0, 0] },
              t: 60,
              s: [374, 374, 100],
            },
            {
              i: { x: [0.667, 0.667, 0.667], y: [1, 1, 1] },
              o: { x: [0.05, 0.05, 0.05], y: [0, 0, 0] },
              t: 67,
              s: [374, 344, 100],
            },
            {
              i: { x: [0, 0, 0], y: [1, 1, 1] },
              o: { x: [0.333, 0.333, 0.333], y: [0, 0, 0] },
              t: 74,
              s: [374, 374, 100],
            },
            {
              i: { x: [0, 0, 0], y: [1, 1, 1] },
              o: { x: [0.05, 0.05, 0.05], y: [0, 0, 0] },
              t: 120,
              s: [374, 374, 100],
            },
            {
              i: { x: [0.667, 0.667, 0.667], y: [1, 1, 1] },
              o: { x: [0.05, 0.05, 0.05], y: [0, 0, 0] },
              t: 127,
              s: [374, 344, 100],
            },
            {
              i: { x: [0, 0, 0], y: [1, 1, 1] },
              o: { x: [0.333, 0.333, 0.333], y: [0, 0, 0] },
              t: 134,
              s: [374, 374, 100],
            },
            {
              i: { x: [0, 0, 0], y: [1, 1, 1] },
              o: { x: [0.05, 0.05, 0.05], y: [0, 0, 0] },
              t: 180,
              s: [374, 374, 100],
            },
            {
              i: { x: [0.667, 0.667, 0.667], y: [1, 1, 1] },
              o: { x: [0.05, 0.05, 0.05], y: [0, 0, 0] },
              t: 187,
              s: [374, 344, 100],
            },
            { t: 194, s: [374, 374, 100] },
          ],
          ix: 6,
        },
      },
      ao: 0,
      shapes: [
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [-1.305, 0.595],
                    [-4.952, -0.45],
                    [-2.256, -3.017],
                    [2.829, -7.792],
                    [1.692, -2.76],
                    [2.324, -2.876],
                    [2.415, -1.917],
                    [0.045, -0.033],
                    [0.28, -0.201],
                    [0.484, -0.33],
                    [1.148, -0.686],
                    [1.936, -0.89],
                    [3.173, -0.637],
                    [0.504, -0.083],
                    [0.558, -0.046],
                    [0.175, -0.016],
                    [0.319, -0.001],
                    [-3.41, 0.011],
                    [-3.848, 1.593],
                    [-5.539, 6.665],
                    [-2.854, 7.399],
                    [0.065, 4.731],
                    [2.877, 4.258],
                    [5.345, 0.81],
                    [5.82, -2.656],
                    [-0.669, -1.144],
                  ],
                  o: [
                    [4.41, -2.012],
                    [3.801, 0.345],
                    [5.17, 6.915],
                    [-0.994, 2.738],
                    [-1.932, 3.151],
                    [-1.931, 2.389],
                    [0.479, -0.38],
                    [-0.279, 0.202],
                    [-0.476, 0.342],
                    [-1.105, 0.753],
                    [-1.829, 1.092],
                    [-2.938, 1.351],
                    [-0.501, 0.1],
                    [-0.729, 0.121],
                    [-0.175, 0.014],
                    [-0.317, 0.029],
                    [-3.404, 0.011],
                    [4.228, -0.014],
                    [7.977, -3.303],
                    [5.043, -6.068],
                    [1.711, -4.435],
                    [-0.07, -5.091],
                    [-2.975, -4.403],
                    [-6.516, -0.988],
                    [-1.3, 0.593],
                    [0.781, 1.335],
                  ],
                  v: [
                    [-7.003, -28.612],
                    [7.213, -32.215],
                    [16.64, -26.62],
                    [18.553, -1.732],
                    [14.14, 6.85],
                    [7.773, 15.938],
                    [1.367, 22.622],
                    [1.117, 22.804],
                    [0.281, 23.412],
                    [-1.16, 24.419],
                    [-4.538, 26.579],
                    [-10.188, 29.564],
                    [-19.407, 32.603],
                    [-20.915, 32.868],
                    [-20.995, 32.879],
                    [-21.519, 32.934],
                    [-22.475, 32.992],
                    [-22.475, 38.282],
                    [-9.975, 35.198],
                    [10.859, 20.477],
                    [23.466, 0.171],
                    [25.82, -14.136],
                    [21.652, -28.66],
                    [8.861, -37.305],
                    [-9.673, -33.18],
                    [-10.623, -29.561],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Path 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: { a: 0, k: [0, 0.380392156863, 0.372549019608, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: 'Fill 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: { a: 0, k: [117.634, 119.133], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: 'Transform',
            },
          ],
          nm: 'Group 1',
          np: 2,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [-1.355, 0.472],
                    [-2.547, 10.352],
                    [2.561, 10.533],
                    [5.034, 6.049],
                    [7.841, -2.194],
                    [1.911, -4.121],
                    [0.255, -1.478],
                    [0.081, -0.655],
                    [0.09, -0.333],
                    [-0.071, 0.066],
                    [-0.389, 0.227],
                    [-0.221, 0.029],
                    [-3.399, -0.13],
                    [-0.27, 1.324],
                    [0.182, -1.081],
                    [-0.098, 0.455],
                    [-0.169, 0.508],
                    [0.088, -0.214],
                    [-0.106, 0.199],
                    [-1.359, 1.041],
                    [-3.013, -0.763],
                    [-2.21, -2.221],
                    [-1.497, -2.459],
                    [-1.127, -3.415],
                    [1.563, -9.762],
                    [10.469, -3.65],
                    [-0.396, -1.444],
                  ],
                  o: [
                    [10.615, -3.701],
                    [2.59, -10.531],
                    [-1.847, -7.597],
                    [-4.854, -5.833],
                    [-4.337, 1.214],
                    [-0.63, 1.361],
                    [-0.112, 0.65],
                    [-0.086, 0.696],
                    [-0.184, 0.672],
                    [0.389, -0.227],
                    [0.22, -0.029],
                    [-3.405, -0.13],
                    [1.496, 0.057],
                    [0.032, -0.159],
                    [0.077, -0.459],
                    [0.112, -0.524],
                    [0.038, -0.116],
                    [-0.05, 0.122],
                    [0.746, -1.407],
                    [2.687, -2.057],
                    [2.982, 0.755],
                    [2.038, 2.048],
                    [1.875, 3.081],
                    [3.093, 9.374],
                    [-1.59, 9.927],
                    [-1.349, 0.47],
                    [0.36, 1.309],
                  ],
                  v: [
                    [1.401, 43.792],
                    [20.119, 19.528],
                    [20.11, -12.679],
                    [10.2, -33.79],
                    [-9.806, -42.07],
                    [-20.087, -33.621],
                    [-21.445, -29.375],
                    [-21.719, -27.414],
                    [-21.701, -27.552],
                    [-21.133, -28.391],
                    [-19.966, -29.071],
                    [-19.304, -29.158],
                    [-19.304, -23.868],
                    [-16.569, -26.35],
                    [-16.449, -27.284],
                    [-16.211, -28.656],
                    [-15.792, -30.206],
                    [-15.572, -30.836],
                    [-15.194, -31.607],
                    [-12.378, -34.959],
                    [-3.229, -37.05],
                    [4.489, -32.219],
                    [9.208, -26.167],
                    [13.585, -16.253],
                    [16.047, 13.045],
                    [-0.005, 38.691],
                    [-1.853, 41.945],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Path 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: { a: 0, k: [0, 0.380392156863, 0.372549019608, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: 'Fill 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: { a: 0, k: [94.461, 113.529], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: 'Transform',
            },
          ],
          nm: 'Group 2',
          np: 2,
          cix: 2,
          bm: 0,
          ix: 2,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [-2.893, -1.79],
                    [-7.161, 3.746],
                    [-0.99, 3.345],
                    [0.101, 3.279],
                    [3.728, 7.115],
                    [2.573, 3.931],
                    [1.108, 1.345],
                    [7.672, 3.168],
                    [5.205, -1.582],
                    [1.844, -6.531],
                    [-2.922, -6.679],
                    [-4.425, -4.575],
                    [-1.337, -1.348],
                    [2.401, 2.42],
                    [3.137, 5.058],
                    [0.922, 2.698],
                    [0.182, 3.284],
                    [-1.972, 2.472],
                    [-2.407, 1.278],
                    [-4.287, -1.218],
                    [-2.177, -1.227],
                    [-0.92, -0.62],
                    [-0.457, -0.333],
                    [-0.206, -0.154],
                    [-0.102, -0.078],
                    [-0.336, -0.266],
                    [-2.377, -2.669],
                    [-0.555, -0.676],
                    [-0.05, -0.054],
                    [-0.29, -0.438],
                    [-1.191, -1.894],
                    [-1.596, -7.938],
                    [0.025, -2.834],
                    [0.189, -1.299],
                    [0.169, -0.624],
                    [0.098, -0.282],
                    [0.241, -0.415],
                    [5.296, 1.882],
                    [1.581, 0.978],
                  ],
                  o: [
                    [6.439, 3.983],
                    [3.067, -1.605],
                    [0.937, -3.168],
                    [-0.25, -8.068],
                    [-2.181, -4.164],
                    [-0.954, -1.458],
                    [-5.252, -6.375],
                    [-4.971, -2.053],
                    [-6.323, 1.922],
                    [-2.05, 7.262],
                    [2.574, 5.881],
                    [1.321, 1.365],
                    [2.401, 2.421],
                    [-4.22, -4.256],
                    [-1.505, -2.426],
                    [-1.059, -3.097],
                    [-0.169, -3.047],
                    [1.707, -2.14],
                    [4.058, -2.155],
                    [2.379, 0.675],
                    [0.966, 0.544],
                    [0.469, 0.316],
                    [0.208, 0.152],
                    [0.103, 0.077],
                    [0.343, 0.263],
                    [2.804, 2.215],
                    [0.581, 0.653],
                    [0.046, 0.056],
                    [-0.959, -1.028],
                    [1.237, 1.864],
                    [4.264, 6.782],
                    [0.56, 2.783],
                    [-0.012, 1.395],
                    [-0.094, 0.639],
                    [-0.078, 0.288],
                    [-0.125, 0.361],
                    [-3.223, 5.56],
                    [-1.758, -0.624],
                    [-2.903, -1.796],
                  ],
                  v: [
                    [4.609, 32.531],
                    [26.799, 35.397],
                    [33.466, 27.674],
                    [34.37, 17.736],
                    [27.913, -4.846],
                    [20.657, -16.932],
                    [17.672, -21.206],
                    [-1.953, -36.423],
                    [-17.755, -37.562],
                    [-32.421, -24.044],
                    [-29.082, -1.971],
                    [-17.949, 13.357],
                    [-13.952, 17.417],
                    [-10.211, 13.677],
                    [-21.996, 0.161],
                    [-25.613, -7.54],
                    [-27.812, -17.168],
                    [-25.645, -26.061],
                    [-19.173, -31.292],
                    [-6.413, -32.392],
                    [-0.364, -29.81],
                    [2.464, -28.06],
                    [3.853, -27.086],
                    [4.474, -26.626],
                    [4.78, -26.393],
                    [4.845, -26.341],
                    [12.627, -18.984],
                    [14.321, -16.984],
                    [14.458, -16.811],
                    [14.802, -16.214],
                    [18.454, -10.583],
                    [28.428, 11.336],
                    [29.104, 19.832],
                    [28.841, 24.073],
                    [28.447, 25.974],
                    [28.184, 26.831],
                    [27.962, 27.326],
                    [12.255, 30.566],
                    [7.279, 27.964],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Path 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: { a: 0, k: [0, 0.380392156863, 0.372549019608, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: 'Fill 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: { a: 0, k: [71.553, 120.9], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: 'Transform',
            },
          ],
          nm: 'Group 3',
          np: 2,
          cix: 2,
          bm: 0,
          ix: 3,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [0.187, 1.426],
                    [-2.493, 8.596],
                    [-6.989, 3.053],
                    [-3.49, 0.401],
                    [-3.89, -1.106],
                    [-2.101, -6.053],
                    [-0.497, -9.225],
                    [0.183, 3.408],
                    [2.758, 8.835],
                    [6.964, 3.314],
                    [4.735, -0.243],
                    [3.964, -1.331],
                    [3.473, -7.92],
                    [-1.42, -10.84],
                    [-1.562, 0],
                  ],
                  o: [
                    [-1.142, -8.719],
                    [2.123, -7.321],
                    [3.224, -1.408],
                    [3.983, -0.457],
                    [6.493, 1.845],
                    [3.048, 8.778],
                    [0.182, 3.386],
                    [-0.496, -9.204],
                    [-2.205, -7.061],
                    [-4.328, -2.06],
                    [-4.17, 0.213],
                    [-8.088, 2.716],
                    [-4.513, 10.291],
                    [0.186, 1.416],
                    [1.285, 0],
                  ],
                  v: [
                    [-25.556, 24.094],
                    [-25.365, -2.312],
                    [-11.408, -18.273],
                    [-1.134, -20.955],
                    [10.957, -20.465],
                    [23.31, -6.656],
                    [27.838, 21.001],
                    [33.128, 21.001],
                    [28.888, -6.616],
                    [15.796, -24.25],
                    [1.915, -26.497],
                    [-10.421, -24.278],
                    [-28.797, -8.252],
                    [-30.846, 24.094],
                    [-28.201, 26.739],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Path 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: { a: 0, k: [0, 0.380392156863, 0.372549019608, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: 'Fill 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: { a: 0, k: [83.861, 26.99], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: 'Transform',
            },
          ],
          nm: 'Group 4',
          np: 2,
          cix: 2,
          bm: 0,
          ix: 4,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [3.407, -0.189],
                    [18.271, -1.016],
                    [18.183, -1.011],
                    [9.136, -0.508],
                    [4.568, -0.254],
                    [1.032, -0.033],
                    [0.232, -0.181],
                    [0.017, 0.1],
                    [0.322, 2.216],
                    [1.637, 17.974],
                    [-0.862, 18.123],
                    [-0.158, 2.264],
                    [0.882, -0.882],
                    [-18.02, 1.301],
                    [-18.109, 1.307],
                    [-18.021, 1.301],
                    [-0.891, 0.114],
                    [0.111, 0.116],
                    [-0.016, -0.187],
                    [0.007, -2.055],
                    [0.014, -4.408],
                    [0.029, -8.732],
                    [0.054, -17.415],
                    [0.008, -2.276],
                    [-0.01, 3.409],
                    [-0.058, 17.924],
                    [-0.028, 8.874],
                    [-0.014, 4.468],
                    [-0.008, 2.351],
                    [0.59, 1.871],
                    [3.841, -0.277],
                    [4.659, -0.336],
                    [9.23, -0.666],
                    [18.46, -1.333],
                    [18.459, -1.333],
                    [2.286, -0.165],
                    [0.106, -1.517],
                    [-1.481, -18.425],
                    [-2.657, -18.498],
                    [-0.327, -2.25],
                    [-0.697, -1.931],
                    [-2.25, 0.022],
                    [-2.318, 0.129],
                    [-9.311, 0.517],
                    [-18.623, 1.036],
                    [-18.71, 1.04],
                    [-2.284, 0.127],
                  ],
                  o: [
                    [-18.271, 1.016],
                    [-18.184, 1.011],
                    [-9.136, 0.508],
                    [-4.567, 0.254],
                    [-1.031, 0.057],
                    [-1.458, 0.046],
                    [0.026, -0.021],
                    [-0.382, -2.206],
                    [-2.591, -17.857],
                    [-1.645, -18.057],
                    [0.108, -2.267],
                    [-0.882, 0.882],
                    [18.02, -1.301],
                    [18.108, -1.307],
                    [18.02, -1.301],
                    [0.9, -0.065],
                    [0.194, -0.025],
                    [0.123, 0.129],
                    [0.177, 2.048],
                    [-0.014, 4.409],
                    [-0.028, 8.732],
                    [-0.056, 17.415],
                    [-0.007, 2.276],
                    [-0.01, 3.404],
                    [0.056, -17.924],
                    [0.029, -8.874],
                    [0.014, -4.468],
                    [0.008, -2.351],
                    [0.006, -1.931],
                    [-1.525, -4.828],
                    [-4.659, 0.336],
                    [-9.23, 0.666],
                    [-18.46, 1.333],
                    [-18.46, 1.332],
                    [-2.286, 0.165],
                    [-1.504, 0.109],
                    [-1.292, 18.451],
                    [1.498, 18.633],
                    [0.324, 2.25],
                    [0.294, 2.022],
                    [0.785, 2.179],
                    [2.322, -0.023],
                    [9.312, -0.518],
                    [18.623, -1.036],
                    [18.711, -1.04],
                    [2.284, -0.127],
                    [3.385, -0.188],
                  ],
                  v: [
                    [81.989, 57.648],
                    [27.175, 60.697],
                    [-27.376, 63.729],
                    [-54.784, 65.254],
                    [-68.487, 66.016],
                    [-71.583, 66.185],
                    [-71.771, 66.556],
                    [-71.944, 65.708],
                    [-72.915, 59.053],
                    [-79.633, 5.342],
                    [-81.199, -49.004],
                    [-80.797, -55.799],
                    [-83.442, -53.155],
                    [-29.381, -57.057],
                    [24.944, -60.979],
                    [79.005, -64.883],
                    [81.748, -65.03],
                    [81.669, -65.26],
                    [81.818, -64.564],
                    [81.813, -58.327],
                    [81.772, -45.102],
                    [81.687, -18.905],
                    [81.52, 33.34],
                    [81.498, 40.167],
                    [86.788, 40.167],
                    [86.96, -13.605],
                    [87.046, -40.228],
                    [87.088, -53.632],
                    [87.111, -60.686],
                    [86.789, -66.678],
                    [75.84, -69.944],
                    [61.863, -68.936],
                    [34.174, -66.936],
                    [-21.206, -62.938],
                    [-76.585, -58.939],
                    [-83.442, -58.444],
                    [-86.087, -55.799],
                    [-85.416, -0.401],
                    [-78.766, 55.267],
                    [-77.789, 62.017],
                    [-76.753, 68.292],
                    [-71.779, 71.484],
                    [-64.798, 71.1],
                    [-36.864, 69.547],
                    [19.005, 66.44],
                    [75.137, 63.319],
                    [81.989, 62.939],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Path 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: { a: 0, k: [0, 0.380392156863, 0.372549019608, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: 'Fill 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: { a: 0, k: [87.629, 113.857], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: 'Transform',
            },
          ],
          nm: 'Group 5',
          np: 2,
          cix: 2,
          bm: 0,
          ix: 5,
          mn: 'ADBE Vector Group',
          hd: false,
        },
      ],
      ip: 60,
      op: 244,
      st: 60,
      bm: 0,
    } as ShapeLayer,
    {
      ddd: 0,
      ind: 4,
      ty: 4,
      nm: 'SURPRISE BAG - MASK 5',
      parent: 1,
      td: 1,
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [88, 49.535, 0], ix: 2 },
        a: { a: 0, k: [0, 0, 0], ix: 1 },
        s: { a: 0, k: [26.738, 26.738, 100], ix: 6 },
      },
      ao: 0,
      shapes: [
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [260, -14],
                    [-9, 8],
                    [-308, 29],
                    [-317, 77],
                    [-307, 267],
                    [-278, 483],
                    [-264, 493],
                    [-251, 495],
                    [307, 466],
                    [316, 384],
                    [309, 278],
                    [311, -1],
                    [304, -13],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Path 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'st',
              c: { a: 0, k: [0, 0.380391977348, 0.372548989689, 1], ix: 3 },
              o: { a: 0, k: 100, ix: 4 },
              w: { a: 0, k: 5, ix: 5 },
              lc: 1,
              lj: 1,
              ml: 4,
              bm: 0,
              nm: 'Stroke 1',
              mn: 'ADBE Vector Graphic - Stroke',
              hd: false,
            },
            {
              ty: 'fl',
              c: { a: 0, k: [0.886274988511, 0.988234994926, 0.890196018593, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: 'Fill 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: { a: 0, k: [0, 0], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: 'Transform',
            },
          ],
          nm: 'Shape 1',
          np: 3,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: 'ADBE Vector Group',
          hd: false,
        },
      ],
      ip: 120,
      op: 185,
      st: 0,
      bm: 0,
    } as ShapeLayer,
    {
      ddd: 0,
      ind: 5,
      ty: 4,
      nm: 'APPLE Outlines',
      parent: 6,
      tt: 2,
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 4.473, ix: 10 },
        p: { a: 0, k: [568.743, 520.021, 0], ix: 2 },
        a: { a: 0, k: [25.412, 30.567, 0], ix: 1 },
        s: { a: 0, k: [420, 420, 100], ix: 6 },
      },
      ao: 0,
      shapes: [
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [1.348, -0.176],
                    [1.21, -6.56],
                    [-3.106, -2.012],
                    [-1.605, 2.422],
                    [2.374, 1.886],
                    [3.398, 0.371],
                    [2.613, -5.791],
                    [-0.807, -5.697],
                    [-5.057, -3.908],
                    [-7.95, 11.351],
                    [-0.368, 3.637],
                    [0.574, 3.599],
                    [7.214, 0.288],
                    [1.491, -0.751],
                    [-2.87, 1.444],
                    [-1.236, -3.541],
                    [0.052, -2.824],
                    [0.68, -2.632],
                    [9.18, 2.997],
                    [2.412, 4.052],
                    [-0.198, 4.422],
                    [-3.431, 3.144],
                    [-3.653, -1.912],
                    [-0.663, -0.431],
                    [-0.229, -0.034],
                    [-0.032, 0.054],
                    [0.045, -0.146],
                    [0.195, -0.349],
                    [0.154, -0.211],
                    [0.313, -0.368],
                    [0.114, -0.096],
                    [0.148, -0.093],
                    [0.635, -0.117],
                    [0.073, 0.179],
                    [-0.188, -0.322],
                    [-0.003, 0.476],
                    [-1.135, 2.164],
                    [-2.431, 0.318],
                    [0, 1.476],
                  ],
                  o: [
                    [-7.103, 0.928],
                    [-0.608, 3.296],
                    [2.64, 1.71],
                    [1.596, -2.408],
                    [-2.671, -2.121],
                    [-6.395, -0.697],
                    [-2.37, 5.249],
                    [0.902, 6.364],
                    [10.812, 8.353],
                    [2.135, -3.048],
                    [0.366, -3.619],
                    [-1.042, -6.535],
                    [-1.685, -0.068],
                    [-2.875, 1.446],
                    [4.216, -2.121],
                    [0.937, 2.685],
                    [-0.05, 2.708],
                    [-2.657, 10.277],
                    [-4.51, -1.472],
                    [-2.298, -3.859],
                    [0.199, -4.433],
                    [3.095, -2.836],
                    [0.7, 0.367],
                    [0.196, 0.128],
                    [-0.134, -0.02],
                    [-0.079, 0.132],
                    [-0.184, 0.594],
                    [-0.128, 0.227],
                    [0.059, -0.081],
                    [-0.102, 0.109],
                    [0.188, -0.144],
                    [-0.345, 0.167],
                    [0.542, -0.1],
                    [0.142, 0.347],
                    [-0.272, -0.464],
                    [0.014, -2.455],
                    [1.078, -2.055],
                    [1.339, -0.175],
                    [0, -1.215],
                  ],
                  v: [
                    [5.442, -30.141],
                    [-6.703, -16.273],
                    [-4.126, -7.39],
                    [3.082, -9.373],
                    [2.214, -16.416],
                    [-7.055, -20.373],
                    [-22.119, -11.552],
                    [-24.355, 5.81],
                    [-14.745, 21.964],
                    [21.473, 16.737],
                    [24.741, 6.349],
                    [24.588, -4.533],
                    [11.514, -18.417],
                    [6.733, -17.265],
                    [9.256, -12.948],
                    [18.934, -6.583],
                    [20.012, 1.743],
                    [19.127, 9.847],
                    [-6.095, 21.029],
                    [-16.831, 12.219],
                    [-19.573, -0.167],
                    [-15.102, -12.964],
                    [-3.684, -14.25],
                    [-1.639, -13.052],
                    [-0.694, -12.388],
                    [-0.718, -13.06],
                    [-0.864, -12.539],
                    [-0.899, -12.471],
                    [-1.298, -11.804],
                    [-1.333, -11.781],
                    [-1.657, -11.474],
                    [-1.597, -11.55],
                    [-1.691, -11.528],
                    [-1.474, -11.594],
                    [-1.825, -11.869],
                    [-2.036, -13.304],
                    [-0.008, -20.677],
                    [5.442, -25.141],
                    [7.942, -27.641],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Path 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: { a: 0, k: [0, 0.380392156863, 0.372549019608, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: 'Fill 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: { a: 0, k: [25.412, 30.567], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: 'Transform',
            },
          ],
          nm: 'Group 1',
          np: 2,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: 'ADBE Vector Group',
          hd: false,
        },
      ],
      ip: 122,
      op: 184,
      st: 0,
      bm: 0,
    } as ShapeLayer,
    {
      ddd: 0,
      ind: 6,
      ty: 3,
      nm: 'MAKI',
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: {
          a: 1,
          k: [
            { i: { x: [0.667], y: [1] }, o: { x: [0.333], y: [0] }, t: 122, s: [-30] },
            {
              t: 196,
              s: [45],
            },
          ],
          ix: 10,
        },
        p: {
          a: 1,
          k: [
            {
              i: { x: 0, y: 1 },
              o: { x: 0, y: 0 },
              t: 122,
              s: [502, 634.95, 0],
              to: [0, -65.158, 0],
              ti: [0, -15.1, 0],
            },
            {
              i: { x: 1, y: 1 },
              o: { x: 1, y: 0 },
              t: 150.713,
              s: [502, 243.999, 0],
              to: [0, 15.1, 0],
              ti: [0, -80.258, 0],
            },
            { t: 179.43359375, s: [502, 725.55, 0] },
          ],
          ix: 2,
          x: "var $bm_rt;\nvar enable, amp, freq, decay, n, t, v;\ntry {\n    $bm_rt = enable = effect('Excite - Position')('Pseudo/BNCA2506f0b33-0001');\n    if (enable == 0) {\n        $bm_rt = value;\n    } else {\n        amp = $bm_div(effect('Excite - Position')('Pseudo/BNCA2506f0b33-0003'), 2.5);\n        freq = $bm_div(effect('Excite - Position')('Pseudo/BNCA2506f0b33-0004'), 20);\n        decay = $bm_div(effect('Excite - Position')('Pseudo/BNCA2506f0b33-0005'), 20);\n        n = 0, 0 < numKeys && (n = nearestKey(time).index, key(n).time > time && n--), t = 0 === n ? 0 : $bm_sub(time, key(n).time), $bm_rt = 0 < n ? (v = velocityAtTime($bm_sub(key(n).time, $bm_div(thisComp.frameDuration, 10))), $bm_sum(value, $bm_div($bm_mul($bm_mul($bm_div(v, 100), amp), Math.sin($bm_mul($bm_mul($bm_mul(freq, t), 2), Math.PI))), Math.exp($bm_mul(decay, t))))) : value;\n    }\n} catch (err) {\n    $bm_rt = value = value;\n}",
        },
        a: { a: 0, k: [540, 540, 0], ix: 1 },
        s: { a: 0, k: [100, 100, 100], ix: 6 },
      },
      ao: 0,
      ip: 120,
      op: 185,
      st: 0,
      bm: 0,
    } as NullLayer,
    {
      ddd: 0,
      ind: 7,
      ty: 4,
      nm: 'SURPRISE BAG - MASK 4',
      parent: 1,
      td: 1,
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [88, 49.535, 0], ix: 2 },
        a: { a: 0, k: [0, 0, 0], ix: 1 },
        s: { a: 0, k: [26.738, 26.738, 100], ix: 6 },
      },
      ao: 0,
      shapes: [
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [260, -14],
                    [-9, 8],
                    [-308, 29],
                    [-317, 77],
                    [-307, 267],
                    [-278, 483],
                    [-264, 493],
                    [-251, 495],
                    [307, 466],
                    [316, 384],
                    [309, 278],
                    [311, -1],
                    [304, -13],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Path 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'st',
              c: { a: 0, k: [0, 0.380391977348, 0.372548989689, 1], ix: 3 },
              o: { a: 0, k: 100, ix: 4 },
              w: { a: 0, k: 5, ix: 5 },
              lc: 1,
              lj: 1,
              ml: 4,
              bm: 0,
              nm: 'Stroke 1',
              mn: 'ADBE Vector Graphic - Stroke',
              hd: false,
            },
            {
              ty: 'fl',
              c: { a: 0, k: [0.886274988511, 0.988234994926, 0.890196018593, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: 'Fill 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: { a: 0, k: [0, 0], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: 'Transform',
            },
          ],
          nm: 'Shape 1',
          np: 3,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: 'ADBE Vector Group',
          hd: false,
        },
      ],
      ip: 120,
      op: 185,
      st: 0,
      bm: 0,
    } as ShapeLayer,
    {
      ddd: 0,
      ind: 8,
      ty: 4,
      nm: 'CARROT Outlines',
      parent: 9,
      tt: 2,
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 4.207, ix: 10 },
        p: { a: 0, k: [23.576, -11.148, 0], ix: 2 },
        a: { a: 0, k: [27.594, 46.791, 0], ix: 1 },
        s: { a: 0, k: [336, 336, 100], ix: 6 },
      },
      ao: 0,
      shapes: [
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [-1.106, 0.787],
                    [1.262, 3.555],
                    [1.153, 1.789],
                    [-0.293, 1.933],
                    [-1.851, -1.513],
                    [-0.109, -0.619],
                    [0.035, -0.331],
                    [-0.041, 3.954],
                    [-0.156, -0.063],
                    [-0.022, -0.08],
                    [0.412, 0.09],
                    [0.114, 0.022],
                    [-0.672, -0.234],
                    [-0.281, -0.292],
                    [-0.057, -0.195],
                    [0.004, -0.002],
                    [-0.079, 0.39],
                    [-0.096, 0.278],
                    [-0.448, 0.762],
                    [-0.875, 1.771],
                    [-1.365, 1.249],
                    [-1.498, -0.592],
                    [1.347, -1.994],
                    [0.152, -1.114],
                    [-0.889, -0.912],
                    [-1.748, 1.082],
                    [-0.528, 0.64],
                    [-0.279, 0.256],
                    [-0.139, 0.016],
                    [0.241, -1.016],
                    [1.374, -0.632],
                    [1.102, -1.824],
                    [0.151, -1.909],
                    [1.016, -0.315],
                    [0.612, 0.117],
                    [1.145, 0.12],
                    [1.121, -2.105],
                    [-1.69, -1.405],
                    [-0.654, -1.559],
                    [2.081, -2.946],
                    [6.107, -8.417],
                    [1.586, -1.604],
                    [0.439, -0.373],
                    [-0.001, 0.004],
                    [-0.138, -0.043],
                    [0.1, 0.517],
                    [0.07, 0.509],
                    [-0.473, 2.285],
                    [-0.582, 2.367],
                    [-3.404, 8.501],
                    [-0.373, 0.631],
                    [0.131, -0.165],
                    [-0.09, 0.066],
                    [-0.575, 0.294],
                    [2.862, -1.464],
                    [0.745, -1.712],
                    [0.712, -1.905],
                    [1.517, -5.452],
                    [1.03, -5.722],
                    [-1.385, -2.516],
                    [-2.409, 1.729],
                    [-1.686, 2.207],
                    [-1.703, 2.354],
                    [-3.491, 4.823],
                    [-0.963, 5.402],
                    [1.002, 2.234],
                    [1.754, 1.41],
                    [0.024, -0.025],
                    [0.111, 0.105],
                    [-0.21, -0.018],
                    [-0.563, -0.115],
                    [-2.123, 1.375],
                    [-0.255, 2.366],
                    [-1.224, 1.041],
                    [-0.828, 0.382],
                    [-0.885, 0.771],
                    [0.186, 2.442],
                    [3.753, -4.287],
                    [0.088, 0.149],
                    [-0.107, -0.123],
                    [-0.081, -0.13],
                    [-0.157, 0.291],
                    [-0.142, 0.199],
                    [-0.305, 2.2],
                    [1.57, 1.852],
                    [2.464, -0.272],
                    [1.689, -1.803],
                    [1.123, -2.021],
                    [-2.175, -4.258],
                    [-1.15, 4.23],
                    [5.103, 0.183],
                    [0.033, -4.457],
                    [-1.432, -2.226],
                    [-0.489, -2.144],
                    [0.065, -0.436],
                    [-0.092, 0.201],
                    [0.098, -0.14],
                    [-0.333, 0.237],
                    [-0.725, -1.239],
                  ],
                  o: [
                    [3.291, -2.341],
                    [-0.722, -2.031],
                    [-0.991, -1.537],
                    [0.316, -2.082],
                    [0.495, 0.405],
                    [0.053, 0.302],
                    [0.014, -0.128],
                    [-0.005, 0.48],
                    [0.151, 0.061],
                    [-0.075, -0.275],
                    [0.465, 0.102],
                    [0.752, 0.148],
                    [-0.142, -0.049],
                    [-0.246, -0.255],
                    [0.084, 0.286],
                    [0.048, -0.021],
                    [0.03, -0.151],
                    [0.289, -0.839],
                    [0.999, -1.7],
                    [0.806, -1.63],
                    [1.101, -1.007],
                    [3.028, 1.2],
                    [-0.606, 0.896],
                    [-0.169, 1.235],
                    [1.499, 1.538],
                    [0.715, -0.443],
                    [0.24, -0.291],
                    [0.182, -0.167],
                    [1.255, -0.138],
                    [-0.382, 1.609],
                    [-1.866, 0.86],
                    [-1.017, 1.683],
                    [-0.089, 1.115],
                    [-0.569, 0.177],
                    [-1.129, -0.215],
                    [-2.214, -0.234],
                    [-1.12, 2.103],
                    [1.236, 1.026],
                    [1.566, 3.737],
                    [-5.999, 8.494],
                    [-1.321, 1.822],
                    [-0.405, 0.41],
                    [-0.072, 0.061],
                    [0.006, -0.023],
                    [0.394, 0.123],
                    [-0.097, -0.499],
                    [-0.323, -2.353],
                    [0.495, -2.387],
                    [2.189, -8.887],
                    [0.267, -0.668],
                    [0.101, -0.171],
                    [0.069, -0.087],
                    [0.344, -0.252],
                    [2.865, -1.466],
                    [-1.737, 0.889],
                    [-0.811, 1.867],
                    [-1.981, 5.302],
                    [-1.558, 5.601],
                    [-0.49, 2.722],
                    [1.526, 2.773],
                    [2.276, -1.632],
                    [1.764, -2.31],
                    [3.491, -4.823],
                    [3.113, -4.302],
                    [0.428, -2.398],
                    [-0.963, -2.145],
                    [-0.216, -0.174],
                    [0.158, -0.165],
                    [0.093, 0.088],
                    [0.573, 0.052],
                    [2.33, 0.475],
                    [2.115, -1.368],
                    [0.164, -1.518],
                    [0.703, -0.598],
                    [1.059, -0.488],
                    [1.819, -1.587],
                    [-0.414, -5.41],
                    [-0.271, 0.31],
                    [-0.052, -0.089],
                    [0.081, 0.129],
                    [-0.115, 0.459],
                    [0.189, -0.136],
                    [1.287, -1.808],
                    [0.329, -2.367],
                    [-1.622, -1.915],
                    [-2.466, 0.273],
                    [-1.61, 1.717],
                    [-1.929, 3.47],
                    [2.004, 3.925],
                    [1.329, -4.89],
                    [-4.494, -0.161],
                    [-0.02, 2.71],
                    [1.166, 1.811],
                    [0.151, 0.659],
                    [-0.025, 0.175],
                    [-0.07, 0.153],
                    [0.238, -0.341],
                    [-1.098, 0.781],
                    [0.635, 1.086],
                  ],
                  v: [
                    [-2.187, -6.745],
                    [0.037, -17],
                    [-3.061, -22.398],
                    [-5.067, -27.896],
                    [-0.078, -29.966],
                    [0.799, -28.341],
                    [0.836, -27.328],
                    [0.786, -26.989],
                    [0.831, -26.93],
                    [0.708, -26.841],
                    [0.693, -26.875],
                    [0.71, -26.904],
                    [0.725, -26.89],
                    [0.71, -26.875],
                    [0.735, -26.786],
                    [0.709, -26.921],
                    [0.755, -27.018],
                    [1.016, -27.942],
                    [2.206, -30.323],
                    [5.261, -35.395],
                    [8.204, -39.904],
                    [12.52, -41.149],
                    [12.362, -33.802],
                    [11.028, -31.026],
                    [12.077, -27.533],
                    [17.679, -27.137],
                    [19.458, -28.83],
                    [20.21, -29.689],
                    [20.598, -29.932],
                    [22.099, -27.775],
                    [18.844, -24.802],
                    [14.071, -21.177],
                    [12.774, -15.575],
                    [11.682, -12.682],
                    [9.768, -12.778],
                    [6.377, -13.365],
                    [0.643, -10.938],
                    [2.258, -5.185],
                    [5.698, -1.901],
                    [2.644, 8.664],
                    [-15.646, 33.948],
                    [-19.898, 39.175],
                    [-21.159, 40.362],
                    [-22.028, 40.962],
                    [-21.659, 41.203],
                    [-21.652, 41.031],
                    [-22.019, 39.544],
                    [-21.074, 32.385],
                    [-19.458, 25.255],
                    [-11.1, -0.956],
                    [-10.148, -2.93],
                    [-9.743, -3.546],
                    [-9.487, -3.802],
                    [-9.367, -3.839],
                    [-11.891, -8.156],
                    [-15.365, -3.627],
                    [-17.534, 2.081],
                    [-22.784, 18.224],
                    [-26.711, 35.221],
                    [-25.959, 43.583],
                    [-18.769, 44.812],
                    [-13.011, 38.745],
                    [-7.874, 31.698],
                    [2.599, 17.227],
                    [10.922, 2.943],
                    [10.148, -4.13],
                    [5.794, -8.721],
                    [5.123, -9.307],
                    [4.915, -8.398],
                    [6.015, -8.401],
                    [7.715, -8.102],
                    [14.662, -8.599],
                    [17.689, -14.601],
                    [18.853, -19.169],
                    [21.367, -20.484],
                    [24.308, -22.286],
                    [27.158, -28.81],
                    [16.288, -32.807],
                    [14.806, -31.253],
                    [15.695, -30.971],
                    [15.937, -30.583],
                    [16, -30.333],
                    [16.493, -31.01],
                    [18.998, -37.172],
                    [17.287, -43.729],
                    [10.594, -46.27],
                    [4.166, -42.938],
                    [0.556, -37.182],
                    [-3.718, -24.554],
                    [5.572, -25.531],
                    [-1.64, -35.568],
                    [-10.088, -27.416],
                    [-7.379, -19.875],
                    [-4.406, -14.372],
                    [-4.255, -12.25],
                    [-4.426, -11.526],
                    [-4.691, -11.07],
                    [-4.711, -11.062],
                    [-5.607, -7.641],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Path 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: { a: 0, k: [0, 0.380392156863, 0.372549019608, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: 'Fill 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: { a: 0, k: [27.594, 46.792], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: 'Transform',
            },
          ],
          nm: 'Group 1',
          np: 2,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: 'ADBE Vector Group',
          hd: false,
        },
      ],
      ip: 125,
      op: 180,
      st: 0,
      bm: 0,
    } as ShapeLayer,
    {
      ddd: 0,
      ind: 9,
      ty: 3,
      nm: 'NIGIRI 2',
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: {
          a: 1,
          k: [
            { i: { x: [0.667], y: [1] }, o: { x: [0.333], y: [0] }, t: 125, s: [-30] },
            {
              t: 196,
              s: [20],
            },
          ],
          ix: 10,
        },
        p: {
          a: 1,
          k: [
            {
              i: { x: 0, y: 1 },
              o: { x: 0, y: 0 },
              t: 125,
              s: [691, 643.95, 0],
              to: [0, -59.492, 0],
              ti: [0, -17.6, 0],
            },
            {
              i: { x: 1, y: 1 },
              o: { x: 1, y: 0 },
              t: 152.551,
              s: [691, 287, 0],
              to: [0, 17.6, 0],
              ti: [0, -77.092, 0],
            },
            { t: 180.10546875, s: [691, 749.55, 0] },
          ],
          ix: 2,
          x: "var $bm_rt;\nvar enable, amp, freq, decay, n, t, v;\ntry {\n    $bm_rt = enable = effect('Excite - Position')('Pseudo/BNCA2506f0b33-0001');\n    if (enable == 0) {\n        $bm_rt = value;\n    } else {\n        amp = $bm_div(effect('Excite - Position')('Pseudo/BNCA2506f0b33-0003'), 2.5);\n        freq = $bm_div(effect('Excite - Position')('Pseudo/BNCA2506f0b33-0004'), 20);\n        decay = $bm_div(effect('Excite - Position')('Pseudo/BNCA2506f0b33-0005'), 20);\n        n = 0, 0 < numKeys && (n = nearestKey(time).index, key(n).time > time && n--), t = 0 === n ? 0 : $bm_sub(time, key(n).time), $bm_rt = 0 < n ? (v = velocityAtTime($bm_sub(key(n).time, $bm_div(thisComp.frameDuration, 10))), $bm_sum(value, $bm_div($bm_mul($bm_mul($bm_div(v, 100), amp), Math.sin($bm_mul($bm_mul($bm_mul(freq, t), 2), Math.PI))), Math.exp($bm_mul(decay, t))))) : value;\n    }\n} catch (err) {\n    $bm_rt = value = value;\n}",
        },
        a: { a: 0, k: [0, 0, 0], ix: 1 },
        s: { a: 0, k: [125, 125, 100], ix: 6 },
      },
      ao: 0,
      hasMask: true,
      masksProperties: [
        {
          inv: false,
          mode: 's',
          pt: {
            a: 0,
            k: {
              i: [
                [8.401, 0],
                [0, 0],
                [2.94, 7.988],
                [-0.414, 0.227],
                [-8.169, 1.226],
                [-16.95, -1.414],
                [-6.956, -3.23],
                [-0.927, -0.418],
              ],
              o: [
                [0, 0],
                [-8.597, 0],
                [0.405, -0.219],
                [4.92, -2.679],
                [20.096, -3.015],
                [9.772, 0.814],
                [0.954, 0.443],
                [-3.056, 7.742],
              ],
              v: [
                [39.527, 28.5],
                [-39.473, 28.5],
                [-58.698, 15.059],
                [-57.47, 14.392],
                [-38.805, 7.45],
                [31.153, 6.484],
                [55.767, 14.19],
                [58.586, 15.486],
              ],
              c: true,
            },
            ix: 1,
          },
          o: { a: 0, k: 100, ix: 3 },
          x: { a: 0, k: 0, ix: 4 },
          nm: 'Mask 1',
        },
        {
          inv: false,
          mode: 's',
          pt: {
            a: 0,
            k: {
              i: [
                [12.323, -1.849],
                [5.299, -2.888],
                [3.617, 1.976],
                [0.1, 1.552],
                [-5.387, 3.917],
                [-11.676, 1.861],
                [0, 0],
                [-1.603, 0],
                [-0.686, 0.397],
                [-0.31, 1.161],
                [0.602, 1.04],
                [0, 0],
                [-7.624, 0.054],
                [0, 0],
                [-1.603, 0],
                [-0.686, 0.397],
                [-0.31, 1.161],
                [0.602, 1.04],
                [0, 0],
                [-5.919, -0.432],
                [0, 0],
                [-1.603, 0],
                [-0.686, 0.397],
                [-0.31, 1.161],
                [0.602, 1.04],
                [0, 0],
                [-5.87, -3.424],
                [-0.729, -7.086],
                [1.312, -1.181],
                [9.513, 4.418],
                [11.366, 0.947],
                [11.636, 0],
              ],
              o: [
                [-9.749, 1.463],
                [-6.508, 3.547],
                [-1.684, -0.918],
                [-0.417, -6.427],
                [5.748, -4.181],
                [0, 0],
                [0.801, 1.386],
                [0.789, 0],
                [1.039, -0.602],
                [0.31, -1.162],
                [0, 0],
                [5.614, -0.458],
                [0, 0],
                [0.801, 1.386],
                [0.789, 0],
                [1.039, -0.602],
                [0.31, -1.162],
                [0, 0],
                [7.538, 0.095],
                [0, 0],
                [0.801, 1.386],
                [0.789, 0],
                [1.039, -0.602],
                [0.31, -1.162],
                [0, 0],
                [11.652, 1.528],
                [8.342, 4.866],
                [0.195, 1.901],
                [-3.516, 3.16],
                [-7.258, -3.371],
                [-9.038, -0.753],
                [-11.002, 0],
              ],
              v: [
                [-40.141, -1.45],
                [-61.783, 6.493],
                [-74.317, 9.05],
                [-76.829, 5.571],
                [-61.825, -16.361],
                [-38.116, -25.586],
                [-28.367, -8.747],
                [-24.471, -6.499],
                [-22.217, -7.106],
                [-20.125, -9.841],
                [-20.579, -13.254],
                [-28.377, -26.723],
                [-8.638, -27.486],
                [1.633, -9.747],
                [5.529, -7.5],
                [7.783, -8.106],
                [9.875, -10.841],
                [9.421, -14.254],
                [1.778, -27.456],
                [21.835, -26.67],
                [31.633, -9.747],
                [35.529, -7.5],
                [37.783, -8.106],
                [39.875, -10.841],
                [39.421, -14.254],
                [32.871, -25.569],
                [59.26, -18.113],
                [78.132, 4.198],
                [76.517, 8.655],
                [59.558, 6.028],
                [31.901, -2.484],
                [-1.114, -3.687],
              ],
              c: true,
            },
            ix: 1,
          },
          o: { a: 0, k: 100, ix: 3 },
          x: { a: 0, k: 0, ix: 4 },
          nm: 'Mask 2',
        },
      ],
      ip: 120,
      op: 185,
      st: 0,
      bm: 0,
    } as NullLayer,
    {
      ddd: 0,
      ind: 10,
      ty: 4,
      nm: 'SURPRISE BAG - MASK 3',
      parent: 1,
      td: 1,
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [88, 49.535, 0], ix: 2 },
        a: { a: 0, k: [0, 0, 0], ix: 1 },
        s: { a: 0, k: [26.738, 26.738, 100], ix: 6 },
      },
      ao: 0,
      shapes: [
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [260, -14],
                    [-9, 8],
                    [-308, 29],
                    [-317, 77],
                    [-307, 267],
                    [-278, 483],
                    [-264, 493],
                    [-251, 495],
                    [307, 466],
                    [316, 384],
                    [309, 278],
                    [311, -1],
                    [304, -13],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Path 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'st',
              c: { a: 0, k: [0, 0.380391977348, 0.372548989689, 1], ix: 3 },
              o: { a: 0, k: 100, ix: 4 },
              w: { a: 0, k: 5, ix: 5 },
              lc: 1,
              lj: 1,
              ml: 4,
              bm: 0,
              nm: 'Stroke 1',
              mn: 'ADBE Vector Graphic - Stroke',
              hd: false,
            },
            {
              ty: 'fl',
              c: { a: 0, k: [0.886274988511, 0.988234994926, 0.890196018593, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: 'Fill 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: { a: 0, k: [0, 0], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: 'Transform',
            },
          ],
          nm: 'Shape 1',
          np: 3,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: 'ADBE Vector Group',
          hd: false,
        },
      ],
      ip: 120,
      op: 185,
      st: 0,
      bm: 0,
    } as ShapeLayer,
    {
      ddd: 0,
      ind: 11,
      ty: 4,
      nm: 'ORANGE Outlines',
      parent: 12,
      tt: 2,
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 4.167, ix: 10 },
        p: { a: 0, k: [509.021, 544.205, 0], ix: 2 },
        a: { a: 0, k: [24.526, 29.796, 0], ix: 1 },
        s: { a: 0, k: [420, 420, 100], ix: 6 },
      },
      ao: 0,
      shapes: [
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [0.506, 0.407],
                    [0.116, 0.146],
                    [-0.13, -0.169],
                    [0.088, 0.2],
                    [-0.084, -0.199],
                    [0.037, 0.252],
                    [-0.03, -0.222],
                    [-0.03, 0.253],
                    [0.029, -0.221],
                    [-0.096, 0.235],
                    [0.084, -0.199],
                    [-0.119, 0.162],
                    [0.13, -0.168],
                    [-0.099, 0.093],
                    [0, 0.622],
                    [0.46, 0.422],
                    [0.666, -0.03],
                    [0.497, -0.469],
                    [0.288, -0.762],
                    [0.031, -0.191],
                    [-0.017, -0.407],
                    [-0.353, -0.77],
                    [-0.122, -0.162],
                    [-0.312, -0.252],
                    [-0.31, -0.1],
                    [-0.344, 0.013],
                    [-0.422, 0.459],
                    [0.03, 0.666],
                  ],
                  o: [
                    [-0.145, -0.117],
                    [0.13, 0.169],
                    [-0.133, -0.174],
                    [0.084, 0.199],
                    [-0.097, -0.235],
                    [0.03, 0.221],
                    [-0.032, -0.254],
                    [-0.03, 0.221],
                    [0.033, -0.251],
                    [-0.083, 0.199],
                    [0.081, -0.185],
                    [-0.13, 0.168],
                    [0.082, -0.107],
                    [0.458, -0.432],
                    [0, -0.613],
                    [-0.477, -0.438],
                    [-0.674, 0.03],
                    [-0.602, 0.568],
                    [-0.069, 0.181],
                    [-0.064, 0.395],
                    [0.034, 0.859],
                    [0.084, 0.183],
                    [0.239, 0.319],
                    [0.227, 0.243],
                    [0.298, 0.157],
                    [0.613, 0],
                    [0.437, -0.477],
                    [-0.028, -0.621],
                  ],
                  v: [
                    [2.232, 0.236],
                    [1.842, -0.157],
                    [2.233, 0.349],
                    [1.904, -0.212],
                    [2.156, 0.385],
                    [1.957, -0.344],
                    [2.047, 0.321],
                    [2.043, -0.438],
                    [1.954, 0.226],
                    [2.147, -0.502],
                    [1.895, 0.095],
                    [2.194, -0.425],
                    [1.804, 0.08],
                    [2.075, -0.219],
                    [2.807, -1.987],
                    [2.075, -3.754],
                    [0.307, -4.487],
                    [-1.461, -3.754],
                    [-2.711, -1.738],
                    [-2.857, -1.178],
                    [-2.977, 0.043],
                    [-2.393, 2.358],
                    [-2.084, 2.873],
                    [-1.304, 3.772],
                    [-0.499, 4.288],
                    [0.464, 4.504],
                    [2.232, 3.772],
                    [2.964, 2.004],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Path 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: { a: 0, k: [0, 0.380392156863, 0.372549019608, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: 'Fill 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: { a: 0, k: [13.206, 37.261], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: 'Transform',
            },
          ],
          nm: 'Group 1',
          np: 2,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [0.489, 0.456],
                    [0.098, 0.123],
                    [-0.13, -0.168],
                    [0.108, 0.244],
                    [-0.084, -0.199],
                    [0.041, 0.296],
                    [-0.03, -0.221],
                    [-0.033, 0.265],
                    [0.03, -0.221],
                    [-0.051, 0.164],
                    [0.074, 0.332],
                    [0.183, 0.287],
                    [0.272, 0.176],
                    [0.325, 0.078],
                    [0.568, -0.366],
                    [0.199, -0.641],
                    [0.024, -0.155],
                    [0.005, -0.355],
                    [-0.131, -0.491],
                    [-0.057, -0.137],
                    [-0.175, -0.301],
                    [-0.369, -0.345],
                    [-0.664, 0],
                    [-0.298, 0.157],
                    [-0.226, 0.243],
                    [0.03, 0.666],
                  ],
                  o: [
                    [-0.115, -0.107],
                    [0.13, 0.169],
                    [-0.163, -0.211],
                    [0.084, 0.199],
                    [-0.116, -0.275],
                    [0.03, 0.221],
                    [-0.033, -0.265],
                    [-0.03, 0.221],
                    [0.024, -0.171],
                    [0.104, -0.333],
                    [-0.016, -0.333],
                    [-0.157, -0.291],
                    [-0.242, -0.221],
                    [-0.64, -0.146],
                    [-0.557, 0.36],
                    [-0.046, 0.15],
                    [-0.053, 0.349],
                    [-0.007, 0.508],
                    [0.038, 0.144],
                    [0.132, 0.321],
                    [0.254, 0.437],
                    [0.48, 0.446],
                    [0.344, 0.013],
                    [0.31, -0.1],
                    [0.437, -0.477],
                    [-0.029, -0.65],
                  ],
                  v: [
                    [2.248, -0.155],
                    [1.93, -0.499],
                    [2.321, 0.007],
                    [1.916, -0.676],
                    [2.168, -0.079],
                    [1.933, -0.936],
                    [2.023, -0.272],
                    [2.022, -1.066],
                    [1.932, -0.402],
                    [2.044, -0.904],
                    [2.089, -1.901],
                    [1.792, -2.831],
                    [1.148, -3.532],
                    [0.298, -3.98],
                    [-1.629, -3.728],
                    [-2.778, -2.234],
                    [-2.883, -1.777],
                    [-3.003, -0.716],
                    [-2.806, 0.807],
                    [-2.662, 1.228],
                    [-2.233, 2.182],
                    [-1.288, 3.381],
                    [0.48, 4.113],
                    [1.443, 3.897],
                    [2.248, 3.381],
                    [2.98, 1.613],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Path 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: { a: 0, k: [0, 0.380392156863, 0.372549019608, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: 'Fill 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: { a: 0, k: [16.816, 44.789], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: 'Transform',
            },
          ],
          nm: 'Group 2',
          np: 2,
          cix: 2,
          bm: 0,
          ix: 2,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [0.498, 0.432],
                    [0.183, 0.234],
                    [-0.13, -0.169],
                    [0.155, 0.365],
                    [-0.084, -0.199],
                    [0.054, 0.376],
                    [-0.03, -0.221],
                    [0.007, 0.115],
                    [0.156, 0.298],
                    [0.244, 0.227],
                    [0.31, 0.1],
                    [0.344, -0.013],
                    [0.451, -0.49],
                    [-0.042, -0.66],
                    [-0.129, -0.493],
                    [-0.223, -0.456],
                    [-0.184, -0.243],
                    [-0.389, -0.338],
                    [-0.31, -0.1],
                    [-0.344, 0.013],
                    [-0.298, 0.157],
                    [-0.226, 0.243],
                    [0.03, 0.666],
                  ],
                  o: [
                    [-0.225, -0.195],
                    [0.131, 0.169],
                    [-0.24, -0.315],
                    [0.084, 0.199],
                    [-0.144, -0.351],
                    [0.029, 0.221],
                    [-0.015, -0.114],
                    [0.013, -0.344],
                    [-0.101, -0.31],
                    [-0.227, -0.243],
                    [-0.298, -0.157],
                    [-0.647, 0.029],
                    [-0.432, 0.471],
                    [0.032, 0.508],
                    [0.13, 0.493],
                    [0.134, 0.275],
                    [0.31, 0.411],
                    [0.227, 0.243],
                    [0.298, 0.157],
                    [0.344, 0.013],
                    [0.31, -0.1],
                    [0.437, -0.477],
                    [-0.028, -0.636],
                  ],
                  v: [
                    [2.542, -0.216],
                    [1.932, -0.86],
                    [2.322, -0.354],
                    [1.73, -1.377],
                    [1.981, -0.78],
                    [1.683, -1.872],
                    [1.771, -1.208],
                    [1.738, -1.552],
                    [1.523, -2.515],
                    [1.006, -3.32],
                    [0.2, -3.836],
                    [-0.762, -4.052],
                    [-2.531, -3.32],
                    [-3.262, -1.552],
                    [-3.037, -0.035],
                    [-2.476, 1.394],
                    [-1.994, 2.169],
                    [-0.994, 3.32],
                    [-0.188, 3.836],
                    [0.774, 4.052],
                    [1.738, 3.836],
                    [2.542, 3.32],
                    [3.274, 1.552],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Path 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: { a: 0, k: [0, 0.380392156863, 0.372549019608, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: 'Fill 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: { a: 0, k: [9.68, 42.625], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: 'Transform',
            },
          ],
          nm: 'Group 3',
          np: 2,
          cix: 2,
          bm: 0,
          ix: 3,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [-2.8, -1.592],
                    [0.972, -6.523],
                    [2.342, -2.572],
                    [3.235, -0.427],
                    [5.58, 4.206],
                    [0.638, 3.674],
                    [-2.066, 3.307],
                    [-3.626, 1.683],
                    [-3.716, -0.307],
                    [2.174, 1.079],
                    [1.446, 1.932],
                    [0.299, 1.229],
                    [0.092, 0.562],
                    [0.424, -0.1],
                    [-0.288, -0.24],
                    [-0.416, -0.218],
                    [-0.474, -0.371],
                    [-0.658, -1.07],
                    [-0.129, -2.759],
                    [-1.079, 2.434],
                    [-3.702, 2.21],
                    [2.772, -1.655],
                    [2.07, -4.671],
                    [0, 0],
                    [2.562, 3.37],
                    [1.72, 1.012],
                    [1.947, -0.541],
                    [-1.687, -3.045],
                    [-3.255, -1.615],
                    [-0.42, 1.553],
                    [3.821, -1.534],
                    [2.708, -3.636],
                    [-0.103, -4.712],
                    [-3.162, -3.46],
                    [-8.369, 0.47],
                    [-3.381, 2.492],
                    [-1.179, 4.34],
                    [2.229, 4.92],
                    [3.935, 2.238],
                  ],
                  o: [
                    [5.648, 3.212],
                    [-0.501, 3.363],
                    [-2.242, 2.462],
                    [-6.937, 0.917],
                    [-3.024, -2.279],
                    [-0.673, -3.876],
                    [2.098, -3.36],
                    [3.448, -1.599],
                    [2.452, 0.202],
                    [-2.17, -1.077],
                    [-0.755, -1.009],
                    [-0.138, -0.568],
                    [-0.131, -0.789],
                    [-0.424, 0.1],
                    [0.334, 0.277],
                    [0.532, 0.278],
                    [0.993, 0.775],
                    [1.462, 2.373],
                    [0.105, 2.247],
                    [1.742, -3.933],
                    [2.76, -1.648],
                    [-4.378, 2.614],
                    [0, 0],
                    [-0.195, -4.172],
                    [-1.203, -1.583],
                    [-1.658, -0.976],
                    [-4.652, 1.294],
                    [1.761, 3.179],
                    [0.42, -1.552],
                    [-4.06, -0.336],
                    [-4.233, 1.7],
                    [-2.768, 3.717],
                    [0.1, 4.604],
                    [5.77, 6.316],
                    [4.128, -0.232],
                    [3.692, -2.721],
                    [1.414, -5.204],
                    [-1.867, -4.121],
                    [-2.802, -1.593],
                  ],
                  v: [
                    [10.28, -6.519],
                    [18.685, 9.986],
                    [14.727, 19.874],
                    [5.953, 23.923],
                    [-13.913, 18.656],
                    [-18.927, 9.855],
                    [-16.717, -0.815],
                    [-8.258, -8.675],
                    [2.776, -10.036],
                    [4.038, -14.695],
                    [-1.158, -19.24],
                    [-2.792, -22.555],
                    [-2.961, -24.223],
                    [-3.135, -24.445],
                    [-3.543, -24.079],
                    [-1.993, -23.478],
                    [-0.456, -22.514],
                    [2.034, -19.708],
                    [4.236, -11.821],
                    [8.895, -10.559],
                    [17.112, -19.953],
                    [14.589, -24.271],
                    [4.577, -13.083],
                    [9.236, -11.821],
                    [5.431, -23.553],
                    [1.039, -27.514],
                    [-4.898, -29.005],
                    [-6.343, -18.044],
                    [1.515, -10.378],
                    [2.776, -15.036],
                    [-9.296, -13.631],
                    [-19.575, -5.462],
                    [-24.173, 7.254],
                    [-19.653, 20.195],
                    [4.203, 29.075],
                    [16.021, 25.372],
                    [22.862, 14.245],
                    [21.81, -0.905],
                    [12.804, -10.836],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Path 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: { a: 0, k: [0, 0.380392156863, 0.372549019608, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: 'Fill 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: { a: 0, k: [24.526, 29.796], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: 'Transform',
            },
          ],
          nm: 'Group 4',
          np: 2,
          cix: 2,
          bm: 0,
          ix: 4,
          mn: 'ADBE Vector Group',
          hd: false,
        },
      ],
      ip: 120,
      op: 184,
      st: 0,
      bm: 0,
    } as ShapeLayer,
    {
      ddd: 0,
      ind: 12,
      ty: 3,
      nm: 'MAKI',
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: {
          a: 1,
          k: [
            { i: { x: [0.667], y: [1] }, o: { x: [0.333], y: [0] }, t: 120, s: [-30] },
            {
              t: 196,
              s: [45],
            },
          ],
          ix: 10,
        },
        p: {
          a: 1,
          k: [
            {
              i: { x: 0, y: 1 },
              o: { x: 0, y: 0 },
              t: 120,
              s: [375, 643.95, 0],
              to: [0, -59.492, 0],
              ti: [0, -17.6, 0],
            },
            {
              i: { x: 1, y: 1 },
              o: { x: 1, y: 0 },
              t: 149.49,
              s: [375, 287, 0],
              to: [0, 17.6, 0],
              ti: [0, -77.092, 0],
            },
            { t: 178.986328125, s: [375, 749.55, 0] },
          ],
          ix: 2,
          x: "var $bm_rt;\nvar enable, amp, freq, decay, n, t, v;\ntry {\n    $bm_rt = enable = effect('Excite - Position')('Pseudo/BNCA2506f0b33-0001');\n    if (enable == 0) {\n        $bm_rt = value;\n    } else {\n        amp = $bm_div(effect('Excite - Position')('Pseudo/BNCA2506f0b33-0003'), 2.5);\n        freq = $bm_div(effect('Excite - Position')('Pseudo/BNCA2506f0b33-0004'), 20);\n        decay = $bm_div(effect('Excite - Position')('Pseudo/BNCA2506f0b33-0005'), 20);\n        n = 0, 0 < numKeys && (n = nearestKey(time).index, key(n).time > time && n--), t = 0 === n ? 0 : $bm_sub(time, key(n).time), $bm_rt = 0 < n ? (v = velocityAtTime($bm_sub(key(n).time, $bm_div(thisComp.frameDuration, 10))), $bm_sum(value, $bm_div($bm_mul($bm_mul($bm_div(v, 100), amp), Math.sin($bm_mul($bm_mul($bm_mul(freq, t), 2), Math.PI))), Math.exp($bm_mul(decay, t))))) : value;\n    }\n} catch (err) {\n    $bm_rt = value = value;\n}",
        },
        a: { a: 0, k: [540, 540, 0], ix: 1 },
        s: { a: 0, k: [100, 100, 100], ix: 6 },
      },
      ao: 0,
      ip: 120,
      op: 185,
      st: 0,
      bm: 0,
    } as NullLayer,
    {
      ddd: 0,
      ind: 13,
      ty: 4,
      nm: 'SURPRISE BAG - MASK 2',
      parent: 1,
      td: 1,
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [88, 49.535, 0], ix: 2 },
        a: { a: 0, k: [0, 0, 0], ix: 1 },
        s: { a: 0, k: [26.738, 26.738, 100], ix: 6 },
      },
      ao: 0,
      shapes: [
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [260, -14],
                    [-9, 8],
                    [-308, 29],
                    [-317, 77],
                    [-307, 267],
                    [-278, 483],
                    [-264, 493],
                    [-251, 495],
                    [307, 466],
                    [316, 384],
                    [309, 278],
                    [311, -1],
                    [304, -13],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Path 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'st',
              c: { a: 0, k: [0, 0.380391977348, 0.372548989689, 1], ix: 3 },
              o: { a: 0, k: 100, ix: 4 },
              w: { a: 0, k: 5, ix: 5 },
              lc: 1,
              lj: 1,
              ml: 4,
              bm: 0,
              nm: 'Stroke 1',
              mn: 'ADBE Vector Graphic - Stroke',
              hd: false,
            },
            {
              ty: 'fl',
              c: { a: 0, k: [0.886274988511, 0.988234994926, 0.890196018593, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: 'Fill 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: { a: 0, k: [0, 0], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: 'Transform',
            },
          ],
          nm: 'Shape 1',
          np: 3,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: 'ADBE Vector Group',
          hd: false,
        },
      ],
      ip: 180,
      op: 300,
      st: 0,
      bm: 0,
    } as ShapeLayer,
    {
      ddd: 0,
      ind: 14,
      ty: 4,
      nm: 'CROISSANT Outlines 2',
      parent: 15,
      tt: 2,
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: -22.5, ix: 10 },
        p: { a: 0, k: [-3.201, 7.202, 0], ix: 2 },
        a: { a: 0, k: [37.428, 28.468, 0], ix: 1 },
        s: { a: 0, k: [186.667, 186.667, 100], ix: 6 },
      },
      ao: 0,
      shapes: [
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [1.101, -0.794],
                    [3.138, 2.263],
                    [-0.57, 1.171],
                    [-1.236, 1.598],
                    [-3.33, 2.437],
                    [-1.328, -0.889],
                    [-0.368, -1.185],
                    [0.053, -1.661],
                    [0.367, -0.561],
                    [0.111, -0.039],
                    [0.109, 0.087],
                    [0.192, 0.301],
                    [-1.411, 2.541],
                    [-6.974, -0.602],
                    [-3.779, -7.013],
                    [1.317, -3.167],
                    [2.762, -0.768],
                    [1.309, 0.392],
                    [0.254, 0.149],
                    [0.087, 0.043],
                    [0.104, -0.411],
                    [-0.211, 0.047],
                    [-0.261, 0.127],
                    [-3.055, -0.817],
                    [-0.473, -3.212],
                    [1.885, -3.591],
                    [0.581, -0.823],
                    [-0.335, 0.026],
                    [0.251, 0.125],
                    [0.756, 1.346],
                    [3.447, 1.333],
                    [3.461, 0.791],
                    [2.328, 2.096],
                    [0.404, 1.386],
                    [-0.905, -3.1],
                    [-4.309, -1.734],
                    [-4.189, -1.18],
                    [-1.685, -1.271],
                    [-1.001, -1.929],
                    [-2.77, -0.156],
                    [-1.321, 2.464],
                    [0.898, 5.808],
                    [4.816, 1.365],
                    [3.963, -2.355],
                    [-1.51, -2.567],
                    [-2.382, -0.266],
                    [-2.784, 3.402],
                    [1.207, 4.748],
                    [4.22, 2.861],
                    [5.247, 0.633],
                    [4.49, -9.944],
                    [-3.194, -3.812],
                    [-2.348, 2.041],
                    [0.43, 2.779],
                    [4.635, 1.201],
                    [2.298, -1.746],
                    [1.878, -1.982],
                    [1.576, -2.233],
                    [-0.099, -2.756],
                    [-4.746, 1.254],
                    [-2.174, 1.569],
                    [0.728, 1.245],
                  ],
                  o: [
                    [-2.504, 1.807],
                    [-1.084, -0.781],
                    [0.887, -1.823],
                    [2.518, -3.256],
                    [1.217, -0.891],
                    [0.889, 0.595],
                    [0.49, 1.577],
                    [-0.025, 0.783],
                    [-0.203, 0.311],
                    [0.564, -0.197],
                    [-0.282, -0.225],
                    [-1.628, -2.559],
                    [3.833, -6.902],
                    [7.499, 0.648],
                    [1.579, 2.93],
                    [-1.105, 2.657],
                    [-1.301, 0.361],
                    [-0.283, -0.085],
                    [0.115, 0.067],
                    [-0.424, -0.207],
                    [-0.095, 0.372],
                    [0.252, -0.055],
                    [2.826, -1.384],
                    [3.154, 0.844],
                    [0.613, 4.162],
                    [-0.468, 0.891],
                    [-0.212, 0.301],
                    [-0.286, 0.022],
                    [-1.482, -0.743],
                    [-1.854, -3.295],
                    [-3.331, -1.288],
                    [-2.987, -0.683],
                    [-1.075, -0.968],
                    [-0.9, -3.083],
                    [1.355, 4.639],
                    [4.063, 1.634],
                    [2.012, 0.567],
                    [1.792, 1.35],
                    [1.211, 2.334],
                    [3.153, 0.177],
                    [2.693, -5.024],
                    [-0.763, -4.934],
                    [-4.413, -1.251],
                    [-2.351, 1.397],
                    [1.285, 2.184],
                    [4.449, 0.496],
                    [3.123, -3.816],
                    [-1.269, -4.991],
                    [-4.426, -3.001],
                    [-9.567, -1.154],
                    [-1.949, 4.319],
                    [1.992, 2.377],
                    [2.286, -1.987],
                    [-0.642, -4.148],
                    [-2.936, -0.761],
                    [-2.175, 1.653],
                    [-1.88, 1.985],
                    [-1.51, 2.14],
                    [0.2, 5.533],
                    [2.627, -0.694],
                    [1.093, -0.789],
                    [-0.632, -1.08],
                  ],
                  v: [
                    [-21.332, -0.977],
                    [-30.991, 1.784],
                    [-31.751, -1.006],
                    [-28.31, -6.157],
                    [-19.474, -15.017],
                    [-15.182, -16.119],
                    [-13.323, -12.961],
                    [-12.422, -7.934],
                    [-13.108, -6.352],
                    [-13.317, -6.277],
                    [-13.116, -6.292],
                    [-13.765, -7.014],
                    [-13.447, -15.46],
                    [6.458, -22.234],
                    [25.805, -11.87],
                    [26.773, -2.02],
                    [20.467, 3.552],
                    [16.557, 3.555],
                    [15.761, 3.236],
                    [15.425, 3.024],
                    [15.338, 3.058],
                    [15.324, 3.324],
                    [16.207, 2.768],
                    [25.772, 1.672],
                    [31.42, 8.235],
                    [28.34, 20.036],
                    [26.862, 22.741],
                    [26.727, 23.063],
                    [26.022, 22.888],
                    [23.266, 18.456],
                    [14.807, 11.78],
                    [4.482, 9.246],
                    [-4.114, 5.496],
                    [-6.359, 2.043],
                    [-11.181, 3.372],
                    [-1.675, 12.585],
                    [10.947, 15.768],
                    [16.66, 18.342],
                    [20.192, 23.495],
                    [26.228, 28.041],
                    [32.227, 23.369],
                    [36.28, 7.192],
                    [27.268, -3.104],
                    [13.232, -1.308],
                    [10.976, 5.417],
                    [17.315, 8.768],
                    [29.125, 3.565],
                    [31.891, -9.941],
                    [23.058, -22.059],
                    [8.105, -27.064],
                    [-18.307, -16.896],
                    [-17.259, -3.361],
                    [-9.636, -2.727],
                    [-7.668, -10.511],
                    [-14.488, -21.228],
                    [-22.517, -18.946],
                    [-28.6, -13.459],
                    [-33.784, -7.105],
                    [-37.079, 0.28],
                    [-25.887, 7.158],
                    [-18.808, 3.34],
                    [-17.911, -0.08],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Path 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: { a: 0, k: [0, 0.380392156863, 0.372549019608, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: 'Fill 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: { a: 0, k: [37.428, 28.468], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: 'Transform',
            },
          ],
          nm: 'Group 1',
          np: 2,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: 'ADBE Vector Group',
          hd: false,
        },
      ],
      ip: 180,
      op: 720.720720720721,
      st: 0,
      bm: 0,
    } as ShapeLayer,
    {
      ddd: 0,
      ind: 15,
      ty: 3,
      nm: 'CROISSANT 2',
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: {
          a: 1,
          k: [
            { i: { x: [0.667], y: [1] }, o: { x: [0.333], y: [0] }, t: 180, s: [-30] },
            {
              t: 240,
              s: [45],
            },
          ],
          ix: 10,
        },
        p: {
          a: 1,
          k: [
            {
              i: { x: 0, y: 1 },
              o: { x: 0, y: 0 },
              t: 180,
              s: [540, 710.95, 0],
              to: [0, -81.492, 0],
              ti: [0, 4.4, 0],
            },
            {
              i: { x: 1, y: 1 },
              o: { x: 1, y: 0 },
              t: 210,
              s: [540, 222, 0],
              to: [0, -4.4, 0],
              ti: [0, -77.092, 0],
            },
            { t: 240, s: [540, 684.55, 0] },
          ],
          ix: 2,
          x: "var $bm_rt;\nvar enable, amp, freq, decay, n, t, v;\ntry {\n    $bm_rt = enable = effect('Excite - Position')('Pseudo/BNCA2506f0b33-0001');\n    if (enable == 0) {\n        $bm_rt = value;\n    } else {\n        amp = $bm_div(effect('Excite - Position')('Pseudo/BNCA2506f0b33-0003'), 2.5);\n        freq = $bm_div(effect('Excite - Position')('Pseudo/BNCA2506f0b33-0004'), 20);\n        decay = $bm_div(effect('Excite - Position')('Pseudo/BNCA2506f0b33-0005'), 20);\n        n = 0, 0 < numKeys && (n = nearestKey(time).index, key(n).time > time && n--), t = 0 === n ? 0 : $bm_sub(time, key(n).time), $bm_rt = 0 < n ? (v = velocityAtTime($bm_sub(key(n).time, $bm_div(thisComp.frameDuration, 10))), $bm_sum(value, $bm_div($bm_mul($bm_mul($bm_div(v, 100), amp), Math.sin($bm_mul($bm_mul($bm_mul(freq, t), 2), Math.PI))), Math.exp($bm_mul(decay, t))))) : value;\n    }\n} catch (err) {\n    $bm_rt = value = value;\n}",
        },
        a: { a: 0, k: [0, 0, 0], ix: 1 },
        s: { a: 0, k: [225, 225, 100], ix: 6 },
      },
      ao: 0,
      hasMask: true,
      masksProperties: [
        {
          inv: false,
          mode: 's',
          pt: {
            a: 0,
            k: {
              i: [
                [2.211, -2.692],
                [1.499, -0.366],
                [-2.931, 8.136],
                [-4.05, -3.012],
              ],
              o: [
                [-2.023, 2.462],
                [-3.436, -4.221],
                [3.358, 3.107],
                [-2.152, 1.744],
              ],
              v: [
                [-45.06, 26.506],
                [-52.282, 33.836],
                [-50.243, 9.765],
                [-38.547, 19.459],
              ],
              c: true,
            },
            ix: 1,
          },
          o: { a: 0, k: 100, ix: 3 },
          x: { a: 0, k: 0, ix: 4 },
          nm: 'Mask 1',
        },
        {
          inv: false,
          mode: 's',
          pt: {
            a: 0,
            k: {
              i: [
                [1.53, -0.918],
                [2.816, 4.678],
                [-6.064, 4.478],
                [0, 0],
              ],
              o: [
                [-4.161, -2.049],
                [-0.585, -2.973],
                [0, 0],
                [-3.082, 2.662],
              ],
              v: [
                [-27.214, 20.523],
                [-51.386, 0.82],
                [-34.629, -16.609],
                [-19.089, 14.139],
              ],
              c: true,
            },
            ix: 1,
          },
          o: { a: 0, k: 100, ix: 3 },
          x: { a: 0, k: 0, ix: 4 },
          nm: 'Mask 2',
        },
        {
          inv: false,
          mode: 's',
          pt: {
            a: 0,
            k: {
              i: [
                [4.609, 0],
                [0, 0],
                [2.088, 4.134],
                [0, 0],
                [-0.64, 1.836],
                [-1.775, 0.819],
                [-20.408, 0],
                [-0.03, -0.013],
                [1.798, -3.756],
                [0, 0],
              ],
              o: [
                [0, 0],
                [-4.632, 0],
                [0, 0],
                [-0.891, -1.763],
                [0.64, -1.837],
                [0.072, -0.033],
                [20.157, 0],
                [3.725, 1.865],
                [0, 0],
                [-1.992, 4.158],
              ],
              v: [
                [3.342, 20.693],
                [-1.181, 20.693],
                [-13.579, 13.068],
                [-30.247, -19.91],
                [-30.637, -25.491],
                [-26.882, -29.614],
                [1.106, -32.864],
                [27.716, -29.955],
                [31.208, -19.76],
                [15.518, 13.022],
              ],
              c: true,
            },
            ix: 1,
          },
          o: { a: 0, k: 100, ix: 3 },
          x: { a: 0, k: 0, ix: 4 },
          nm: 'Mask 3',
        },
        {
          inv: false,
          mode: 's',
          pt: {
            a: 0,
            k: {
              i: [
                [2.919, 2.493],
                [0, 0],
                [0.557, -2.905],
                [4.157, -2.047],
              ],
              o: [
                [0, 0],
                [6.072, 4.492],
                [-2.846, 4.743],
                [-1.428, -0.857],
              ],
              v: [
                [20.713, 14.674],
                [35.671, -16.579],
                [52.416, 0.754],
                [28.215, 20.523],
              ],
              c: true,
            },
            ix: 1,
          },
          o: { a: 0, k: 100, ix: 3 },
          x: { a: 0, k: 0, ix: 4 },
          nm: 'Mask 4',
        },
        {
          inv: false,
          mode: 's',
          pt: {
            a: 0,
            k: {
              i: [
                [3.393, -4.251],
                [2, 2.435],
                [2.153, 1.744],
                [-3.36, 3.108],
              ],
              o: [
                [-1.612, -0.432],
                [-2.211, -2.69],
                [4.051, -3.013],
                [2.923, 8.113],
              ],
              v: [
                [53.313, 33.801],
                [46.06, 26.505],
                [39.544, 19.461],
                [51.244, 9.765],
              ],
              c: true,
            },
            ix: 1,
          },
          o: { a: 0, k: 100, ix: 3 },
          x: { a: 0, k: 0, ix: 4 },
          nm: 'Mask 5',
        },
      ],
      ip: 180,
      op: 245,
      st: 0,
      bm: 0,
    } as NullLayer,
    {
      ddd: 0,
      ind: 16,
      ty: 4,
      nm: 'SURPRISE BAG - MASK',
      parent: 1,
      td: 1,
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [88, 49.535, 0], ix: 2 },
        a: { a: 0, k: [0, 0, 0], ix: 1 },
        s: { a: 0, k: [26.738, 26.738, 100], ix: 6 },
      },
      ao: 0,
      shapes: [
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [260, -14],
                    [-9, 8],
                    [-308, 29],
                    [-317, 77],
                    [-307, 267],
                    [-278, 483],
                    [-264, 493],
                    [-251, 495],
                    [307, 466],
                    [316, 384],
                    [309, 278],
                    [311, -1],
                    [304, -13],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Path 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'st',
              c: { a: 0, k: [0, 0.380391977348, 0.372548989689, 1], ix: 3 },
              o: { a: 0, k: 100, ix: 4 },
              w: { a: 0, k: 5, ix: 5 },
              lc: 1,
              lj: 1,
              ml: 4,
              bm: 0,
              nm: 'Stroke 1',
              mn: 'ADBE Vector Graphic - Stroke',
              hd: false,
            },
            {
              ty: 'fl',
              c: { a: 0, k: [0.886274988511, 0.988234994926, 0.890196018593, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: 'Fill 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: { a: 0, k: [0, 0], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: 'Transform',
            },
          ],
          nm: 'Shape 1',
          np: 3,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: 'ADBE Vector Group',
          hd: false,
        },
      ],
      ip: 0,
      op: 122,
      st: 0,
      bm: 0,
    } as ShapeLayer,
    {
      ddd: 0,
      ind: 17,
      ty: 4,
      nm: 'PIZZA/Mystore Loader_Icons Outlines',
      parent: 18,
      tt: 2,
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 14.5, ix: 10 },
        p: { a: 0, k: [5.366, 10.113, 0], ix: 2 },
        a: { a: 0, k: [36, 48, 0], ix: 1 },
        s: { a: 0, k: [152.727, 152.727, 100], ix: 6 },
      },
      ao: 0,
      shapes: [
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [2.7, 1.738],
                    [8.786, 3.464],
                    [4.508, 1.272],
                    [4.497, -1.478],
                    [-2.07, -4.349],
                    [-3.335, -0.995],
                    [-9.156, -3.688],
                    [-2.47, -1.097],
                    [-1.288, -0.599],
                    [-0.187, 0.049],
                    [-0.058, -0.005],
                    [0.186, -0.149],
                    [0.575, -0.46],
                    [1.151, -0.918],
                    [2.302, -1.836],
                    [0, 0],
                    [7.084, -6.232],
                    [-1.578, -3.994],
                    [-4.348, 0.204],
                    [-2.162, 3.988],
                    [1.958, -2.2],
                    [9.992, -11.254],
                    [1.204, -1.421],
                    [0.599, -0.725],
                    [0.413, -0.903],
                    [0, 0],
                    [-0.384, -0.161],
                    [0.189, -0.217],
                    [-0.016, 0.032],
                    [-0.031, 0.306],
                    [-0.354, 3.472],
                    [-0.297, 2.916],
                    [0.834, -0.834],
                    [-3.385, 2.316],
                    [1.761, 4.093],
                    [4.095, -0.815],
                    [0.49, -3.846],
                    [-0.501, 2.767],
                    [-2.573, 14.193],
                    [1.384, 0.38],
                    [0.242, -1.335],
                    [2.573, -14.193],
                    [-1.637, -0.221],
                    [-1.551, 0.209],
                    [-0.292, -2.143],
                    [1.747, -0.706],
                    [2.601, 0.305],
                    [0.124, -1.212],
                    [0.654, -6.41],
                    [-1.251, -1.202],
                    [-1.415, 1.427],
                    [-1.283, 1.523],
                    [-5.636, 5.84],
                    [-6.002, 6.744],
                    [1.309, 1.01],
                    [2.747, 4.85],
                    [-1.844, 1.705],
                    [-2.626, -0.517],
                    [-2.3, -2.485],
                    [-1.023, 0.816],
                    [-3.9, 3.112],
                    [0.574, 2.499],
                    [2.094, 0.961],
                    [9.198, 3.013],
                    [4.346, 1.448],
                    [1.076, 0.928],
                    [-0.464, 1.15],
                    [-1.48, 0.004],
                    [-2.039, -0.526],
                    [-4.26, -1.556],
                    [-8.572, -5.518],
                  ],
                  o: [
                    [-7.941, -5.112],
                    [-4.357, -1.717],
                    [-4.349, -1.227],
                    [-4.28, 1.407],
                    [1.586, 3.332],
                    [9.447, 2.819],
                    [2.507, 1.01],
                    [1.297, 0.576],
                    [0.162, 0.075],
                    [0.018, -0.005],
                    [-0.156, -0.013],
                    [-0.574, 0.461],
                    [-1.151, 0.918],
                    [-2.302, 1.837],
                    [0, 0],
                    [-5.851, -6.322],
                    [-3.157, 2.778],
                    [1.6, 4.047],
                    [4.521, -0.212],
                    [1.304, -2.404],
                    [-10.004, 11.243],
                    [-1.237, 1.393],
                    [-0.608, 0.717],
                    [-0.634, 0.768],
                    [0, 0],
                    [0.377, -0.29],
                    [0.315, 0.099],
                    [0.024, -0.028],
                    [0.142, -0.277],
                    [0.355, -3.472],
                    [0.298, -2.916],
                    [-0.833, 0.833],
                    [3.92, 0.459],
                    [3.498, -2.394],
                    [-1.696, -3.943],
                    [-3.981, 0.793],
                    [-0.354, 2.775],
                    [2.573, -14.193],
                    [0.24, -1.328],
                    [-1.212, -0.333],
                    [-2.573, 14.194],
                    [1.637, 0.221],
                    [0.216, -1.695],
                    [1.929, -0.261],
                    [0.276, 2.031],
                    [-2.486, 1.004],
                    [-1.436, -0.169],
                    [-0.654, 6.409],
                    [-0.157, 1.539],
                    [1.444, 1.387],
                    [1.4, -1.412],
                    [5.231, -6.209],
                    [6.269, -6.493],
                    [-1.309, -1.01],
                    [-2.228, 4.11],
                    [-1.282, -2.263],
                    [1.986, -1.838],
                    [3.359, 0.662],
                    [0.99, 1.07],
                    [3.9, -3.112],
                    [1.806, -1.441],
                    [-0.574, -2.5],
                    [-8.796, -4.036],
                    [-4.358, -1.428],
                    [-1.376, -0.459],
                    [-0.914, -0.789],
                    [0.623, -1.546],
                    [2.123, -0.006],
                    [4.392, 1.134],
                    [9.579, 3.498],
                    [2.714, 1.747],
                  ],
                  v: [
                    [32.826, -27.111],
                    [7.666, -39.976],
                    [-5.642, -44.466],
                    [-19.697, -46.106],
                    [-24.777, -35.837],
                    [-15.973, -29.829],
                    [11.977, -20.439],
                    [19.44, -17.279],
                    [23.318, -15.517],
                    [24.8, -14.775],
                    [24.971, -15.148],
                    [23.766, -14.065],
                    [22.041, -12.687],
                    [18.588, -9.933],
                    [11.682, -4.423],
                    [15.218, -4.423],
                    [-7.711, -7.642],
                    [-10.777, 3.759],
                    [-0.75, 10.206],
                    [10.26, 3.349],
                    [6.333, 0.319],
                    [-24.594, 33.19],
                    [-28.258, 37.409],
                    [-30.069, 39.572],
                    [-32.16, 42.148],
                    [-32.457, 42.52],
                    [-31.316, 42.326],
                    [-30.453, 43.233],
                    [-30.439, 43.093],
                    [-30.32, 41.939],
                    [-29.257, 31.522],
                    [-28.363, 22.773],
                    [-30.863, 25.273],
                    [-18.935, 23.389],
                    [-15.151, 12.526],
                    [-25.535, 7.496],
                    [-32.388, 15.516],
                    [-27.479, 16.181],
                    [-20.685, -26.547],
                    [-22.431, -29.623],
                    [-25.505, -27.877],
                    [-32.299, 14.852],
                    [-27.388, 15.516],
                    [-24.232, 12.321],
                    [-19.495, 15.243],
                    [-22.758, 19.801],
                    [-30.863, 20.273],
                    [-33.363, 22.773],
                    [-35.327, 42.002],
                    [-34.275, 46.184],
                    [-29.021, 46.157],
                    [-25.177, 41.482],
                    [-8.732, 23.529],
                    [9.87, 3.855],
                    [5.943, 0.825],
                    [-5.841, 2.573],
                    [-4.323, -3.976],
                    [3.121, -5.958],
                    [11.682, -0.887],
                    [15.218, -0.887],
                    [26.919, -10.223],
                    [29.714, -15.91],
                    [24.766, -20.331],
                    [-2.25, -30.934],
                    [-15.424, -34.897],
                    [-19.366, -36.905],
                    [-20.333, -39.639],
                    [-16.242, -41.614],
                    [-9.987, -40.459],
                    [3, -36.421],
                    [30.302, -22.794],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Path 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: { a: 0, k: [0, 0.380392156863, 0.372549019608, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: 'Fill 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: { a: 0, k: [35.775, 47.834], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: 'Transform',
            },
          ],
          nm: 'Group 1',
          np: 2,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: 'ADBE Vector Group',
          hd: false,
        },
      ],
      ip: 0,
      op: 120,
      st: 0,
      bm: 0,
    } as ShapeLayer,
    {
      ddd: 0,
      ind: 18,
      ty: 3,
      nm: 'APPLE',
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: {
          a: 1,
          k: [
            { i: { x: [0.667], y: [1] }, o: { x: [0.333], y: [0] }, t: 60, s: [-5] },
            {
              t: 120,
              s: [45],
            },
          ],
          ix: 10,
        },
        p: {
          a: 1,
          k: [
            {
              i: { x: 0, y: 1 },
              o: { x: 0, y: 0 },
              t: 60,
              s: [540, 726.35, 0],
              to: [0, -84.058, 0],
              ti: [0, 6.967, 0],
            },
            {
              i: { x: 1, y: 1 },
              o: { x: 1, y: 0 },
              t: 90,
              s: [540, 222, 0],
              to: [0, -6.967, 0],
              ti: [0, -77.092, 0],
            },
            { t: 120, s: [540, 684.55, 0] },
          ],
          ix: 2,
          x: "var $bm_rt;\nvar enable, amp, freq, decay, n, t, v;\ntry {\n    $bm_rt = enable = effect('Excite - Position')('Pseudo/BNCA2506f0b33-0001');\n    if (enable == 0) {\n        $bm_rt = value;\n    } else {\n        amp = $bm_div(effect('Excite - Position')('Pseudo/BNCA2506f0b33-0003'), 2.5);\n        freq = $bm_div(effect('Excite - Position')('Pseudo/BNCA2506f0b33-0004'), 20);\n        decay = $bm_div(effect('Excite - Position')('Pseudo/BNCA2506f0b33-0005'), 20);\n        n = 0, 0 < numKeys && (n = nearestKey(time).index, key(n).time > time && n--), t = 0 === n ? 0 : $bm_sub(time, key(n).time), $bm_rt = 0 < n ? (v = velocityAtTime($bm_sub(key(n).time, $bm_div(thisComp.frameDuration, 10))), $bm_sum(value, $bm_div($bm_mul($bm_mul($bm_div(v, 100), amp), Math.sin($bm_mul($bm_mul($bm_mul(freq, t), 2), Math.PI))), Math.exp($bm_mul(decay, t))))) : value;\n    }\n} catch (err) {\n    $bm_rt = value = value;\n}",
        },
        a: { a: 0, k: [0, 0, 0], ix: 1 },
        s: { a: 0, k: [275, 275, 100], ix: 6 },
      },
      ao: 0,
      hasMask: true,
      masksProperties: [
        {
          inv: false,
          mode: 's',
          pt: {
            a: 0,
            k: {
              i: [
                [-14.616, 8.354],
                [5.138, -4.355],
                [0.72, -0.532],
              ],
              o: [
                [-1.685, 10.59],
                [-0.726, 0.476],
                [-0.268, -5.558],
              ],
              v: [
                [19.891, -40.202],
                [5.909, -17.471],
                [3.739, -15.959],
              ],
              c: true,
            },
            ix: 1,
          },
          o: { a: 0, k: 100, ix: 3 },
          x: { a: 0, k: 0, ix: 4 },
          nm: 'Mask 1',
        },
        {
          inv: false,
          mode: 's',
          pt: {
            a: 0,
            k: {
              i: [
                [5.959, -10.326],
                [0.182, -0.302],
                [0.056, -0.243],
                [9.018, -2.268],
                [1.442, 0.455],
                [6.012, 11.447],
                [-2.855, 7.768],
                [-3.314, 1.333],
                [-1.792, 0],
                [-6.768, -6.917],
                [-1.071, 1.01],
                [-0.564, 0.485],
                [-2.211, 1.857],
                [-5.237, -2.353],
                [-1.273, -3.943],
              ],
              o: [
                [-0.178, 0.308],
                [-0.131, 0.218],
                [-6.441, 10.372],
                [-1.374, 0.359],
                [-9.31, -2.736],
                [-5.544, -10.553],
                [1.43, -3.888],
                [1.546, -0.622],
                [6.42, 0],
                [1.03, 1.051],
                [0.555, -0.523],
                [1.111, -0.713],
                [7.04, -4.433],
                [3.257, 1.464],
                [2.544, 7.876],
              ],
              v: [
                [30.197, 21.019],
                [29.656, 21.933],
                [29.376, 22.629],
                [4.476, 43.052],
                [-5.231, 42.812],
                [-30.073, 19.818],
                [-34.43, -9.885],
                [-27.18, -17.866],
                [-22.149, -18.791],
                [-1.265, -7.996],
                [2.518, -7.921],
                [4.196, -9.433],
                [9.401, -13.298],
                [28.806, -16.753],
                [35.733, -8.489],
              ],
              c: true,
            },
            ix: 1,
          },
          o: { a: 0, k: 100, ix: 3 },
          x: { a: 0, k: 0, ix: 4 },
          nm: 'Mask 2',
        },
      ],
      ip: 0,
      op: 121,
      st: 0,
      bm: 0,
    } as NullLayer,
  ],
  markers: [],
};
